import React, { useEffect, useState, useRef } from 'react';
import { Paper, Popper } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import Fade from '@material-ui/core/Fade';
import Typography from '@material-ui/core/Typography';
//import { isOverflown } from "@material-ui/data-grid";

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      alignItems: "center",
      width: "100%",
      height: "100%",
      position: "relative",
      display: "flex",
      "& .MuiRating-root": {
        marginRight: theme.spacing(1)
      },
      "& .cellValue": {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        marginLeft: "auto",
        marginRight: "auto"
      }
    },
    typography: {
      padding: theme.spacing(2),
      backgroundColor: '#fff',
      color: '#303030 !important',
      borderRadius: '5px'
    },
    showOnTop: {
        zIndex: '9999'
    },
  })
);
function CellExpand(props) {
  const classes = useStyles();
  const { width, value } = props;
  
  const wrapper = useRef(null);
  const cellDiv = useRef(null);
  const cellValue = useRef(null);

  const [anchorEl, setAnchorEl] = useState(null);
  const [showFullCell, setShowFullCell] = useState(false);
  const [showPopper, setShowPopper] = useState(false);

  const showCell = () => {
    setShowFullCell(true);
  };
  const hideCell = () => {
    setShowFullCell(false);
  };

  useEffect(() => {
    if (cellDiv.current) {
      setAnchorEl(cellDiv.current);
    }
  }, []);
  useEffect(() => {
    if (cellValue && cellValue.current) {
      // const isCurrentlyOverflown = isOverflown(cellValue.current);
      setShowPopper(true);
    }
  }, [width]);

  return (
    <div
      ref={wrapper}
      className={classes.root}
      onMouseEnter={showCell}
      onMouseLeave={hideCell}
    >
      <div
        ref={cellDiv}
        style={{
          height: 1,
          width,
          display: "block",
          position: "absolute",
          top: 0
        }}
      />
      <div ref={cellValue} className="cellValue">
        {value}
      </div>
      {showPopper && (
        <Popper
          open={showFullCell && anchorEl != null}
          anchorEl={anchorEl}
          style={{ width, marginLeft: -17, zIndex: '9999' }}
        >
          <Paper
            elevation={1}
            style={{ minHeight: wrapper.current.offsetHeight - 3 }}
          >
            <Typography variant="body2" style={{ padding: 8 }}>
              {value}
            </Typography>
          </Paper>
        </Popper>
      )}
    </div>
  );
}
export function RenderCellExpand(params) {
  return (
    <CellExpand
      value={params.value ? params.value.toString() : ""}
      width={params.colDef.width}
    />
  );
}
